export function formatThousands(value: number) {
    if (!value) {
        return value
    }

    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}
